import {DEMO_DATA_STAGE_SET, LOADING_SET, POPUP_VISIBLE_SET, SHOW_EXTERNAL_CONTENT_SET, SIZE_SET, URL_SET} from './actionTypes'
import {createAction} from "redux-actions"
import {DemoDataStageType} from './constants'
import makeRpcCall from '../../util/jquery_rpc'
import {getFirstName, isFirstAdmin} from '../../loggedInUser/selectors'
import {getDemoDataStage, getLoadExternalWelcomeScreen, getPopupVisible, getShowExternalContent, isNeedToLoadDemoData} from './selectors'
import {BASE_PATH, isOlVersion, CURRENT_PRODUCT, Product} from '../../constants'
import rpcCall from '../../util/rpc/rpcCalls'
import {createAbsoluteLink} from '../../atUtils'
import emitUserEvent from '../../userEvents/emitUserEvent'
import {UserEventsMap} from '../../userEvents/UserEventsMap'
import {isIntercomEnabled, openIntercom} from "../../intercom/initIntercom";
import ClassicBridge from "../../next/ClassicBridge";

export const setLoading = createAction(LOADING_SET)
export const setPopupVisible = createAction(POPUP_VISIBLE_SET)
export const setShowExternalContent = createAction(SHOW_EXTERNAL_CONTENT_SET)
export const setDemoDataStage = createAction(DEMO_DATA_STAGE_SET)
export const setUrl = createAction(URL_SET)
export const setSize = createAction(SIZE_SET)

export const openLightbox = () => (dispatch, getState) => {
    dispatch(setLoading(true))
    dispatch(setPopupVisible(true))

    if (getLoadExternalWelcomeScreen(getState())) {
        dispatch(loadExternalContent())
    } else {
        dispatch(loadInternalContent())
    }
}

const loadInternalContent = () => dispatch => {
    if (!window.location.origin) {
        window.location.origin = window.location.protocol + "//"
                                 + window.location.hostname
                                 + (window.location.port ? ':' + window.location.port : '')
    }
    dispatch(loadContent(createAbsoluteLink('user/w.do')))
}

const loadExternalContent = () => dispatch => {
    rpcCall(
        'WelcomeScreenService.getExternalContentUrl',
        [],
        () => {
            dispatch(setLoading(false))
            dispatch(setPopupVisible(false))
            return true
        }
    ).then(result => dispatch(loadContent(result)))
        .catch((e) => {
            if (process.env.NODE_ENV === 'development') {
                console.log(e)
            } else {
                throw(e)
            }
        })
}

const loadContent = url => (dispatch, getState) => {
    dispatch(setUrl(url))
    const loadTimeout = isOlVersion ? 300000 : 10000
    window.setTimeout(() => {
            if (!getShowExternalContent(getState())) {
                dispatch(setShowExternalContent(false))
                dispatch(setLoading(false))
                dispatch(setPopupVisible(false))
            }
        },
        loadTimeout)
}

export const sendMessage = contentKey => (dispatch, getState) => {
    const win = window.frames[contentKey]
    win.postMessage({userName: getFirstName(getState())}, '*')
    window.addEventListener('message', event => {
        if (event.data.loaded) {
            dispatch(setSize({
                width: event.data.width,
                height: event.data.height,
            }))
            dispatch(setLoading(false))
        }
        if (event.data.closeFrame) {
            dispatch(closeLightbox())
        }
    })
}

export const closeLightbox = (sendUserEvent = true) => (dispatch, getState) => {
    makeRpcCall(
        'WelcomeScreenService.setCurrentUserSeenWelcomeScreen',
        []
    )
    dispatch(setPopupVisible(false))
    dispatch(setShowExternalContent(false))
    dispatch(setLoading(false))
    dispatch(setUrl(''))
    dispatch(setSize({width: 0, height: 0}))
    sendUserEvent && emitUserEvent(UserEventsMap.POPUP_CLOSED)
    dispatch(onWelcomeToProductCallback())
}

export const startLoadingDemoData = () => (dispatch) => {
    const errorHandler = () => {
        dispatch(setDemoDataStage(DemoDataStageType.ERROR))
        return true
    }
    dispatch(setDemoDataStage(DemoDataStageType.ACTIVE))
    rpcCall(
        'DemoDataService.isNeedToLoadDemoData',
        [],
        errorHandler
    ).then(result => {
        if (result === true) {
            rpcCall(
                'DemoDataService.loadDemoData',
                [],
                errorHandler,
            ).then(() => {
                dispatch(setDemoDataStage(DemoDataStageType.COMPLETED))
                dispatch(onWelcomeToProductCallback())
            })
        }
    })
}

const onWelcomeToProductCallback = () => (dispatch, getState) => {
    let isDemoLoaded = getDemoDataStage(getState()) === DemoDataStageType.COMPLETED
    if (isDemoLoaded && !getPopupVisible(getState())) {
        if (isFirstAdmin(getState()) && isNeedToLoadDemoData(getState())) {
            if (CURRENT_PRODUCT === Product.actiTIME) {
                ClassicBridge.onDemoDataJustLoaded()
                if (isIntercomEnabled()) {
                    openIntercom()
                } else {
                    window.openHelpAndSupportMenu(document.createEvent("Event"))
                }
            } else {
                // reload page
                window.location.href = BASE_PATH
            }
        } else {
            // for regular user
            openIntercom()
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/support/welcomeScreen/actions.js